import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheck } from '@redteclab/icons'

import { Heading, IconListItem } from 'base-ui'

export const StoryblokMagazineNewsletterSubscriptionBenefits: FC = () => (
  <div>
    <Heading className="mb-4" level={3} size="s">
      <FormattedMessage id="magazineNewsletterSubscription.benefits.title" />
    </Heading>
    <ul className="flex flex-col gap-2">
      <IconListItem icon={<IconCheck />}>
        <FormattedMessage id="magazineNewsletterSubscription.benefits.regularUpdates" />
      </IconListItem>
      <IconListItem icon={<IconCheck />}>
        <FormattedMessage id="magazineNewsletterSubscription.benefits.treatmentAndStudyInformation" />
      </IconListItem>
      <IconListItem icon={<IconCheck />}>
        <FormattedMessage id="magazineNewsletterSubscription.benefits.cancelation" />
      </IconListItem>
    </ul>
  </div>
)
